import {BaseRepository} from "../../../infrastructure/repositories/base-repository";
import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../../core/bootstrap/models/site-config";
import {PartialGameApiService} from "./partial-game-api.service";
import {PartialGameFactory} from "./partial-game.factory";
import {DeviceStore} from "../../../core/app/device.store";

export class PartialGameRepository extends BaseRepository {
  static injectables = [DomUtils, LoggerUtils, SiteConfig, DeviceStore, PartialGameApiService, PartialGameFactory];
}
